module.exports = __webpack_public_path__ + "img/weddingbands@2x.6d82184.webp";